import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { JwtModule } from "@auth0/angular-jwt";
import { AuthGuard } from './auth.guard';
import { ConfigService } from './shared/utils/config.service';
import { UserService } from './shared/services/user.service';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { AuthService } from './shared/services/auth.service';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { NavMenuComponent } from './navmenu/navmenu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { UserProfileComponent } from './userProfile/userProfile.component';
import { LoginComponent } from './login/login.component';
import { EntryComponent } from './entry/entry.component';
import { CaseComponent } from './case/case.component';
import { ReportComponent } from './report/report.component';
import { CompanyComponent } from './company/company.component';
import { ContactComponent } from './contact/contact.component';
import { TenderComponent } from './etsTender/etsTender.component';
import { EtsProjectComponent } from './etsProject/etsProject.component';
import { EtsReportComponent } from './etsReport/etsReport.component';
import { ListValueComponent } from './listValue/listValue.component';
import { EmailValidator } from './shared/directives/email.validator.directive';
import { UpperCaseInputDirective, HighlightDirective } from './shared/directives/common.directive';

import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { ToggleButtonModule } from 'primeng/togglebutton';

import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { LightboxModule } from 'primeng/lightbox';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GrowlModule } from 'primeng/growl';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';

//service module related
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { MessageService } from 'primeng/api';
import { BcpApprovalRouteService } from './shared/services/approvalRoute/bcpApprovalRoute.service';
import { bcpApprovalRouteComponent } from './shared/services/approvalRoute/bcpApprovalRoute.component';
import { BcpApprovalActionService } from './shared/services/approvalAction/bcpApprovalAction.service';
import { bcpApprovalActionComponent } from './shared/services/approvalAction/bcpApprovalAction.component';
//end service module


export function tokenGetter() {
  return sessionStorage.getItem("jwt");
}

//20211125 Enhancement Start - Add new Report Module - Jelly
//20220617 Enhancement Start - Add new Email Sending Feature - Jelly
@NgModule({
  declarations: [
    AppComponent,
    //individual modules
    NavMenuComponent, HeaderComponent, EntryComponent, UserProfileComponent
    , LoginComponent, HomeComponent, CounterComponent, FetchDataComponent
    , CaseComponent, ReportComponent, CompanyComponent, ContactComponent
    , TenderComponent, EtsProjectComponent, EtsReportComponent, ListValueComponent
    , EmailValidator, UpperCaseInputDirective, HighlightDirective
    //service modules
    , bcpApprovalRouteComponent, bcpApprovalActionComponent
  ],
  imports: [
    BrowserAnimationsModule, MultiSelectModule, NgxQRCodeModule, 
    TableModule, PaginatorModule, 
    DropdownModule, ButtonModule, 
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule, ToggleButtonModule,
    MessageModule, MessagesModule, ConfirmDialogModule, GrowlModule, CalendarModule, RadioButtonModule, FieldsetModule,
    CheckboxModule, InputTextModule, TabViewModule, LightboxModule, FileUploadModule,
    ProgressBarModule, SidebarModule,
    //service module related
    MatDialogModule, DialogModule,
    RouterModule.forRoot([
      /*{ path: 'home', component: HomeComponent},
      { path: 'login', component: LoginComponent },
      { path: 'counter', component: CounterComponent, canActivate: [AuthGuard] },
      { path: 'fetch-data', component: FetchDataComponent, canActivate: [AuthGuard] },
      { path: 'test', component: UserProfileComponent, canActivate: [AuthGuard] },
      { path: '**', redirectTo: 'login' }
      */

      { path: 'login', component: LoginComponent },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'home', component: HomeComponent,
        children: [
          { path: '', component: EntryComponent },
          { path: 'entry', component: EntryComponent },
          { path: 'counter', component: CounterComponent },
          { path: 'fetch-data', component: FetchDataComponent },
          { path: 'userProfile', component: UserProfileComponent },
          { path: 'case', component: CaseComponent },
          { path: 'report', component: ReportComponent },
          { path: 'company', component: CompanyComponent },
          { path: 'contact', component: ContactComponent },
          { path: 'tender', component: TenderComponent },
          { path: 'etsProject', component: EtsProjectComponent },
          { path: 'etsReport', component: EtsReportComponent },
          { path: 'listValue', component: ListValueComponent },
          { path: '**', redirectTo: 'entry' }
        ]
      },
      { path: '**', redirectTo: 'login' }
    ]),
  //20220617 Enhancement End
  //20211125 Enhancement End

    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        whitelistedDomains: ["localhost:58081"],
        blacklistedRoutes: []
      }
    })
  ],
  providers: [AuthGuard, UserService, ConfigService
    , BcpApprovalRouteService, BcpApprovalActionService
    , MessageService
    , AuthService
    , { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    , { provide: MAT_DIALOG_DATA, useValue: {} }
    , { provide: MatDialogRef, useValue: {} }
    , { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false, maxWidth: '100vw' } }  ],
  bootstrap: [AppComponent],
  entryComponents: [
    bcpApprovalRouteComponent, bcpApprovalActionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }


